/**
 * Destinos da navegação global (P23E) — extraído de MainNav.jsx para não
 * misturar exports de componente e de constantes no mesmo arquivo (regra
 * react-refresh/only-export-components). "Leitura" ocupa a posição de
 * destaque logo após "Início", conforme a especificação do App Shell.
 */
export const JOURNEY_NAV_ITEMS = [
  { to: '/inicio', icon: 'home', label: 'Início' },
  { to: '/leitura', icon: 'menu_book', label: 'Leitura' },
  { to: '/chat', icon: 'chat', label: 'Chat' },
  { to: '/trilhas', icon: 'map', label: 'Trilhas' },
  { to: '/caderno', icon: 'auto_stories', label: 'Caderno' },
];

export const TRACKING_NAV_ITEMS = [
  { to: '/insights', icon: 'monitoring', label: 'Progresso' },
];

export const NAV_ITEMS = [...JOURNEY_NAV_ITEMS, ...TRACKING_NAV_ITEMS];

// P23M: os 5 destinos de Jornada (Início, Leitura, Chat, Trilhas, Caderno)
// viram a barra mobile de 6 posições (a 6ª é o botão "Mais") — igual em
// todas as telas, inclusive no Chat. Só Progresso + ações de conta ficam
// atrás do "Mais".
export const MOBILE_PRIMARY_ITEMS = JOURNEY_NAV_ITEMS;
export const MOBILE_MORE_ITEMS = TRACKING_NAV_ITEMS;
